/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CoupleEventDto } from './couple-event-dto.model';


export interface CoupleMeResponseDto { 
    workspaceId: string;
    event: CoupleEventDto;
    groomName: string | null;
    brideName: string | null;
    theme: CoupleMeResponseDto.ThemeEnum;
}
export namespace CoupleMeResponseDto {
    export const ThemeEnum = {
        Romantic: 'romantic',
        Elegant: 'elegant',
        Minimal: 'minimal'
    } as const;
    export type ThemeEnum = typeof ThemeEnum[keyof typeof ThemeEnum];
}


